export default __webpack_public_path__ + "static/media/taroko-trail.a4e4dc69.jpg";